import { Params } from '@angular/router';
import { fromJS, List, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../utils/helpers/model.helper';
import { IFilter } from '../interfaces/filter.interface';
import {
  DateIncrementEnum,
  FilterTypesEnum,
  ReportParamsEnum,
} from '../reports.enum';

export const FILTER_DATE_SCHEMA = Object.freeze({
  TYPE: FilterTypesEnum.date,
  YEARS: List<number>([]),
  SELECTED_YEARS: List<number>([]),
  SELECTED_INCREMENT: DateIncrementEnum,
});
export const RECORD = generateSchema(FILTER_DATE_SCHEMA);
export const KEYS: any = generateKeys(FILTER_DATE_SCHEMA);

export class FilterDate extends Record(RECORD) implements IFilter {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get type(): FilterTypesEnum {
    return this.get(KEYS.TYPE);
  }

  get years(): List<number> {
    return this.get(KEYS.YEARS);
  }

  get selectedYears(): List<number> {
    return this.get(KEYS.SELECTED_YEARS);
  }

  get selectedIncrement(): DateIncrementEnum {
    return this.get(KEYS.SELECTED_INCREMENT);
  }

  get queryParams(): Params {
    return {
      [ReportParamsEnum.years]: this.selectedYears
        .sort((a, b) => a - b)
        .join(','),
      [ReportParamsEnum.date_increment]: this.selectedIncrement,
    };
  }
}
